import type {InfoRowProps} from './types';

const InfoRow: React.FC<InfoRowProps> = ({label, value, dataCy}) => (
  <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 justify-between dark:bg-gray-900 rounded">
    <p className="text-slate-500 text-sm dark:text-slate-100">{label}</p>
    <p
      className="text-sm font-medium text-gray-700 w-1/2 dark:text-gray-100 break-words"
      data-cy={dataCy}
    >
      {value || '-'}
    </p>
  </div>
);

export {InfoRow};
